import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-maintenance-prints-rules',
  templateUrl: './maintenance-prints-rules.component.html',
  styleUrls: ['./maintenance-prints-rules.component.sass']
})
export class MaintenancePrintsRulesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
